module.exports = __webpack_public_path__ + "media/src/images/icon/check-mark-off-bdca86f9e073e8ec60e57ebe9af806e8.png";